// extracted by mini-css-extract-plugin
export default {"aboutText":"AboutUs_aboutText__SFl9g","aboutTitle":"AboutUs_aboutTitle__JTvpe","backtohome":"AboutUs_backtohome__WjjcY","marginDiv":"AboutUs_marginDiv__ZrRHC"};